(ns shared.core.amelia-light.components.card
  (:require [shared.core.style :as style]
            [shared.core.components.icon :as icon]
            [shared.core.util :as util]
            [shared.core.amelia-light.components.icon :as alc]
            ["@up/base-ui/components/ui/card" :refer [Card
                                                      CardHeader
                                                      CardFooter
                                                      CardTitle
                                                      CardAction
                                                      CardDescription
                                                      CardContent]]))

(defn card
  [{:keys [title title-inline-contents subtitle material-icon-type icon-type color style header-style]} & contents]
  (let [title? (not-empty title)
        subtitle? (not-empty subtitle)]
    (into [:div {:style (merge {:display :flex
                                :flex-direction :column
                                :gap 16
                                :padding 16
                                :border (str "1px solid " (style/alc-color "Border/divider_secondary"))
                                :border-radius 8
                                :background (if color
                                              (str "radial-gradient(57.69% 21.52% at 50% 0%, "
                                                   (util/hex->rgba color 0.15)
                                                   " 0%, rgba(38, 146, 246, 0.00) 100%), "
                                                   (style/alc-color "Background/tertiary"))
                                              (style/alc-color "Background/tertiary"))
                                :box-shadow "-20px 9px 4px 2px rgba(0, 0, 0, 0.01)"
                                :width "100%"}
                               style)}
           (when (or title? subtitle? icon-type material-icon-type)
             [:div {:style (merge {:display :flex
                                   :align-items :center
                                   :gap 16}
                                  header-style)}
              (when (or icon-type material-icon-type)
                [:div {:style {:background-color (style/alc-color "Background/secondary")
                               :border (str "1px solid " (style/alc-color "Border/divider_secondary"))
                               :border-radius 8
                               :display :flex
                               :align-items :center
                               :justify-content :center
                               :padding 8}}
                 (if material-icon-type
                   [icon/material-icon {:icon-type material-icon-type
                                        :style {:color (style/alc-color "Icons/primary")
                                                :font-size 16}}]
                   [alc/up-icon {:icon-type icon-type}])])
              (when (or title? subtitle?)
                [:div {:style {:display :flex
                               :flex-direction :column
                               :gap 2
                               :width "100%"}}
                 (when title?
                   (into [:div {:style {:display :flex
                                        :align-items :center
                                        :gap 10
                                        :width "100%"}}
                          [:span {:style {:color (style/alc-color "Text/primary_header")
                                          :font-size 14
                                          :font-weight 400
                                          :line-height 1.43}}
                           title]]
                         (filterv identity title-inline-contents)))
                 (when subtitle?
                   [:span {:style {:color (style/alc-color "Text/secondary")
                                   :font-size 12
                                   :font-weight 400
                                   :line-height 1.33}}
                    subtitle])])])]
          contents)))

(defn up-card [& args] (into [:> Card] args))
(defn up-card-header [& args] (into [:> CardHeader] args))
(defn up-card-footer [& args] (into [:> CardFooter] args))
(defn up-card-title [& args] (into [:> CardTitle] args))
(defn up-card-action [& args] (into [:> CardAction] args))
(defn up-card-description [& args] (into [:> CardDescription] args))
(defn up-card-content [& args] (into [:> CardContent] args))
